import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { StoragePermissionService } from 'src/app/services/storagePermission/storage-permission.service';
import { DomainService } from 'src/app/services/domain/domain.service';
import { DomainsModel } from 'src/app/models/domains.model';
import { WindorefService } from 'src/app/services/window/windoref.service';
import { ToolsService } from '../tools/tools.service';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';

const apiURL = environment.rapi;

@Injectable({
  providedIn: 'root'
})
export class WhoIsIpService {
  constructor(
    private _httpService: HttpClient,
    private _storagePermissionService: StoragePermissionService,
    private _domainService: DomainService,
    private _Storage: StoragePermissionService,
    private _window: WindorefService,
    private _toolsSrv: ToolsService,
    private router: Router
  ) {}

  capitalizeClient(clientIp: string): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const httpOptions = {
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          Accept: 'application/json'
        }
      };
      this._httpService.post(`${apiURL}/api/ip_who_is?user_ip=${clientIp}`, httpOptions).subscribe(
        (response: any) => {
          let { code, data } = response;
          if (code == 200 || code == 302) {
            this._domainService.verifyDomain(data.domain).then((approved) => {
              this.checkCountryCode(data);
              this.setDomainToStorage(data);
              this._Storage.setUserIP(data.ip2location.ip);
              resolve();
            });
          }
        },
        (err) => {
          if (err.status === 403) {
            let { domainRedirect } = this._domainService.getCurrentDomain();
            this._window.getNativeWindow().location.href = `${domainRedirect}`;
            console.warn('blocked country');
          } else if (err.status === 302) {
            this._domainService.verifyDomain(err.error.data.domain).then((approved) => {
              this.checkCountryCode(err.error.data);
              this.setDomainToStorage(err.error.data.origin);
              resolve();
            });
          } else {
            this.checkCountryCode(err.error.data, true);
            this.setDomainToStorage(err.error.data.origin);
            this.router.navigate(['/in-maintenance']);
            resolve();
          }
        }
      );
    });
  }

  checkCountryCode(data: any, inMaintenance= false): void {
    if ((data.origin.includes('lottokings') || data.origin.includes('lotosena')) && data.ip2location !== null && !inMaintenance) {
      const { ip2location } = data;
      this._storagePermissionService.setCountryCode(ip2location.code);
    } else {
      this._toolsSrv.checkSitesArMx(data.origin);
    }
  }

  setDomainToStorage(server: any = []): void {
    const client: DomainsModel = this._domainService.getCurrentDomain();
    let redirect: any;
    if (client.domain.includes('localhost') || client.domain.includes('stage') || client.domain.includes('test')) {
      redirect = client.domainRedirect;
    } else if (server.domain == '54.207.106.119') {
      redirect = client.domainRedirect;
    } else {
      redirect = server.domain;
    }
    this._storagePermissionService.setDomainToRedirect(redirect);
  }

  setEnvironment(): void {
    const domain: DomainsModel = this._domainService.getCurrentDomain();
    if (domain.domain.includes('localhost') || domain.domain.includes('test')) {
      this._storagePermissionService.setEnvironment('test');
    } else if (domain.domain.includes('stage')) {
      this._storagePermissionService.setEnvironment('stage');
    } else {
      this._storagePermissionService.setEnvironment('production');
    }
  }
}
